'use client';

import type { MetaConversion } from './types';

interface Args {
  eventId: string;
  sourceUrl: string;
  email?: string;
  formId?: string;
  formValues?: Record<string, string>;
  meta?: MetaConversion & { fbp?: string; fbc?: string };
}

export interface ConversionDecision {
  /** False only when the platform deliberately refused to count it. */
  track: boolean;
}

/**
 * Sends the server-side events and asks whether this submission counts - a
 * skip condition from the form definition may have matched. A rejection or a
 * request that never landed is not a refusal: the browser events still fire.
 */
export async function requestConversion({
  eventId,
  sourceUrl,
  email,
  formId,
  formValues,
  meta,
}: Args): Promise<ConversionDecision> {
  try {
    const response = await fetch('/api/conversion', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventId,
        sourceUrl,
        email,
        formId,
        formValues,
        meta,
      }),
    });

    const result: { track?: boolean } = await response
      .json()
      .catch(() => ({}) as { track?: boolean });

    if (!response.ok) {
      console.error('[Conversion] Server-side request rejected:', result);
      return { track: true };
    }

    return { track: result.track !== false };
  } catch (err) {
    console.error('[Conversion] Failed to send server-side request:', err);
    return { track: true };
  }
}
